import { faCommentPlus } from "@fortawesome/pro-solid-svg-icons/faCommentPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Menu } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import * as api from "api/Knowledge";
import { FeedClassKey, TimelineClassKey } from "assets/jss/common-styles";
import AdvFilter, { AdvFilterCommand, AdvFilterComponent, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdAuthor, CmdList, CmdPoll, CmdPost, CmdPublishEndDate, CmdPublishStartDate, CmdQuestion, CmdWithComments, CmdWithFile, CmdWithImage, CmdWithLikes, CmdWithThanks, CmdWithVideo, CommandLabels } from "components/AdvFilter/CommonCommands";
import ButtonResetFilter from "components/Buttons/ButtonResetFilter";
import IconButtonAdd from "components/Buttons/IconButtonAdd";
import IconButtonOrderBy from "components/Buttons/IconButtonOrderby";
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import CountFilter from "components/CountFilter";
import GenericListSelection, { IGenericListSelectionProps } from "components/GenericListSelection";
import { MuiFilterAdvancedContainer, MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import AppMessage from "components/Translations/AppMessage";
import LibUtils from "lib/LibUtils";
import { FeedType, PublicationType } from "models/ApiEnums";
import { FeedAttachType, FeedContentUpdate, FeedItemDto, FeedListFilter, FeedListOrderBy } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import * as FeedActions from 'store/feed/actions';
import { FeedState } from "store/feed/reducer";
import { FeedMessageTypes } from "store/feed/windowMessages";
import { ApplicationState } from "store/rootReducer";
import * as SideBarActions from 'store/sidebar/actions';
import PublicationSelectionDrawer from "views/Publication/Dialogs/PublicationSelectionDrawer";
import CardManager from "views/Timeline/Components/CardManager";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAuthorSelectionProps extends IGenericListSelectionProps {
    listId: string;
}

const AuthorSelection: React.FC<IAuthorSelectionProps> = (props) => {
    return (
        <GenericListSelection
            title="Autores das Publicações da Lista"
            showThumbnail={true}
            multi={props.multi}
            onGetData={(searchText, offset, take) => api.listAuthorsSelection(props.listId, searchText, offset, take)}
            onSelect={props.onSelect}
        />
    );
};

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IStateProps {
    feed: FeedState;
}

interface IState {
    advFilters: AdvFilterResult[];
    orderByMenuAnchorEl: any;
    dialog: any;
    postLastError: any;
}

interface IProps {
    listId?: string;

    canAdd: boolean;
    canAddSuggestion: boolean;

    onSidebarResetRequest: () => void;
    onGetRefenrence?: (ref: FeedListItemsComponent) => void;
}

interface IDispatchProps {
    onAddPublication: (publicationId: string) => Promise<void>;
    onReloadPublication: (uid: string, publicationId: string) => Promise<void>;
    onRemovePublication: (uid: string, publicationId: string) => Promise<boolean>;
    onExpandPublication: (uid: string, publicationId: string) => Promise<void>;
    onFeedReset: () => void;
    onUpdateFeedData: (newItemDto: FeedContentUpdate) => void;
    onRemoveFromFeed: (uid: string, publicationId: string) => void;
    onGetFeed: (filter: FeedListFilter, orderBy: FeedListOrderBy, startIndex: number, endIndex: number) => Promise<any>;
    onProcessSuggestionApproval: (uid: string, publicationId: string, actionId: string, approved: boolean, notes: string) => Promise<boolean>;
    onSidebarResetRequest: () => void;
    executeFeedMessage: (messageType: FeedMessageTypes) => void;
}

type Props = IProps & IStateProps & IDispatchProps & StyledComponentProps<TimelineClassKey | FeedClassKey> & WithSnackbar & WithTranslation;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class FeedListItemsComponent extends React.Component<Props, IState> {

    private advFilterRef: AdvFilterComponent;
    private filter: FeedListFilter;
    private orderBy: FeedListOrderBy = FeedListOrderBy.RecentlyAdded;


    constructor(props: Props) {
        super(props);
        this.state = {
            advFilters: [],
            orderByMenuAnchorEl: null,
            dialog: null,
            postLastError: null
        };
        this.resetFilter(props);
    }


    ///
    public feedReset() {
        this.props.onFeedReset();
    }

    //#region FILTER


    ///
    private get commands(): AdvFilterCommand[] {
        const cmdLabels = CommandLabels();
        return [
            { keyword: CmdWithLikes, displayName: cmdLabels[CmdWithLikes], group: 1 },
            { keyword: CmdWithThanks, displayName: cmdLabels[CmdWithThanks], group: 1 },
            { keyword: CmdWithComments, displayName: cmdLabels[CmdWithComments], group: 1 },

            { keyword: CmdWithVideo, displayName: cmdLabels[CmdWithVideo], group: 2 },
            { keyword: CmdWithImage, displayName: cmdLabels[CmdWithImage], group: 2 },
            { keyword: CmdWithFile, displayName: cmdLabels[CmdWithFile], group: 2 },

            { keyword: CmdPost, displayName: cmdLabels[CmdPost], group: 3 },
            { keyword: CmdQuestion, displayName: cmdLabels[CmdQuestion], group: 3 },
            { keyword: CmdList, displayName: cmdLabels[CmdList], group: 3 },
            { keyword: CmdPoll, displayName: cmdLabels[CmdPoll], group: 3 },

            { keyword: CmdPublishStartDate, displayName: cmdLabels[CmdPublishStartDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdPublishEndDate, displayName: cmdLabels[CmdPublishEndDate], picker: AdvFilterPicker.Calendar, group: 4 },

            {
                keyword: CmdAuthor,
                displayName: cmdLabels[CmdAuthor],
                canRepeat: true,
                group: 5,
                picker: AdvFilterPicker.Custom,
                customPicker: (p: IGenericListSelectionProps): React.ReactElement => {
                    return <AuthorSelection listId={this.props.listId} {...p} />;
                },
            },
        ];
    }

    ///
    private resetFilter(props: Props) {
        this.filter = {
            listId: props.listId,

            attachTypes: null,
            authors: null,
            endDate: null,
            publicationTypes: null,
            searchText: null,
            startDate: null,
            withComments: null,
            withLikes: null,
            withThanks: null
        };
    }

    ///
    private isFiltered() {
        return !LibUtils.isAllPropertiesWithValue(this.filter, null, ["listId"]);
    }

    ///
    private applyOrder = (orderBy: FeedListOrderBy) => {
        this.orderBy = orderBy;
        this.closeOrderBy();
        this.feedReset();
    };

    ///
    private handleUpdateFilter = (searchText: string, advFilters: AdvFilterResult[]) => {
        if (searchText.length == 0 && advFilters.length == 0) {
            this.resetFilter(this.props);
        }
        else {
            this.filter.searchText = searchText.length == 0 ? null : searchText;

            this.filter.publicationTypes = [];
            if (advFilters.findIndex(x => x.keyword == CmdPost) > -1) this.filter.publicationTypes.push(PublicationType.Post);
            if (advFilters.findIndex(x => x.keyword == CmdList) > -1) this.filter.publicationTypes.push(PublicationType.List);
            if (advFilters.findIndex(x => x.keyword == CmdQuestion) > -1) this.filter.publicationTypes.push(PublicationType.Question);
            if (advFilters.findIndex(x => x.keyword == CmdPoll) > -1) this.filter.publicationTypes.push(PublicationType.Poll);

            this.filter.attachTypes = [];
            if (advFilters.findIndex(x => x.keyword == CmdWithVideo) > -1) this.filter.attachTypes.push(FeedAttachType.Video);
            if (advFilters.findIndex(x => x.keyword == CmdWithImage) > -1) this.filter.attachTypes.push(FeedAttachType.Image);
            if (advFilters.findIndex(x => x.keyword == CmdWithFile) > -1) this.filter.attachTypes.push(FeedAttachType.File);

            this.filter.withLikes = advFilters.findIndex(x => x.keyword == CmdWithLikes) > -1;
            this.filter.withThanks = advFilters.findIndex(x => x.keyword == CmdWithThanks) > -1;
            this.filter.withComments = advFilters.findIndex(x => x.keyword == CmdWithComments) > -1;

            const authors = [];
            const a = advFilters.find(x => x.keyword == CmdAuthor); if (a != null) authors.push(a.value);

            var dt = advFilters.find(x => x.keyword == CmdPublishStartDate);
            this.filter.startDate = dt ? (dt.value as Date).putStartOfDay() : null;

            dt = advFilters.find(x => x.keyword == CmdPublishEndDate);
            this.filter.endDate = dt ? (dt.value as Date).putEndOfDay() : null;
        }

        this.setState({ advFilters }, () => this.feedReset());
    };

    ///
    private renderAdvFilter(): JSX.Element {
        const { canAdd, canAddSuggestion } = this.props;

        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>
                        {
                            canAdd &&
                            <div>
                                <IconButtonAdd
                                    color="inherit"
                                    title={this.props.t("Common.Feed.Actions.AddPublicationTitle")}
                                    onClick={() => this.handleAdd(false)}
                                />
                            </div>
                        }
                        {
                            canAddSuggestion &&
                            <div>
                                <IconButton
                                    color="inherit"
                                    title={this.props.t("Common.Feed.Actions.AddSuggestionTitle")}
                                    onClick={() => this.handleAdd(true)}
                                >
                                    <FontAwesomeIcon icon={faCommentPlus} />
                                </IconButton>

                            </div>
                        }

                        <MuiPushRight>
                            <IconButtonOrderBy
                                color="inherit"
                                onClick={
                                    (e) => {
                                        this.setState({ orderByMenuAnchorEl: e.currentTarget });
                                    }
                                }
                            />
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.orderByMenuAnchorEl}
                                open={this.state.orderByMenuAnchorEl != null}
                                onClose={this.closeOrderBy}
                            >
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.RecentlyAdded")} value={FeedListOrderBy.RecentlyAdded} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent")} value={FeedListOrderBy.MostRecent} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostLiked")} value={FeedListOrderBy.MostLiked} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostCommented")} value={FeedListOrderBy.MostComments} currentSelection={this.orderBy} onClick={this.applyOrder} />
                                <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostViewed")} value={FeedListOrderBy.MostViewed} currentSelection={this.orderBy} onClick={this.applyOrder} />
                            </Menu>
                        </MuiPushRight>
                    </MuiFilterLine>

                    <MuiFilterAdvancedContainer>
                        <AdvFilter
                            id="advfilter"
                            commands={this.commands}
                            innerRef={(ref) => this.advFilterRef = ref}
                            placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                            placeHolderFocus={this.props.t("Common.Filter.Adv.InputPlaceholderFocus")}
                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                            selectedCommands={this.state.advFilters}
                            onUpdateSelection={this.handleUpdateFilter} />
                    </MuiFilterAdvancedContainer>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    ///
    private closeOrderBy = () => {
        this.setState({ orderByMenuAnchorEl: null });
    };

    //#endregion

    ///
    private handleAdd(isSuggestion: boolean) {
        this.setState({
            dialog: (
                <PublicationSelectionDrawer
                    excludeOptions={
                        {
                            excludePublicationsType: [PublicationType.Poll, PublicationType.Survey, PublicationType.Course],
                            excludePublicationsFromListId: this.filter.listId
                        }
                    }
                    onSelect={
                        (result) => {
                            if (result != null) {
                                api.listAddPublication(this.filter.listId, result.publication.publicationId, result.comment)
                                    .then((added) => {
                                        if (added) {
                                            this.props.onAddPublication(result.publication.publicationId);
                                            this.props.snackbar.showMessage(this.props.t("Common.Feed.Messages.ListPublicationAddedSuccess"), "success");
                                        }
                                    })
                                    .catch((error) => {
                                        this.setState({ dialog: null, postLastError: error });
                                    });
                            }
                            return true;
                        }
                    }

                    onClose={
                        () => this.setState({ dialog: null })
                    }
                />
            )
        });
    }

    ///
    private handleBeforeDelete = (uid: string, item: FeedItemDto): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {

            this.setState({
                dialog: (
                    <MuiConfirmation
                        title={this.props.t("Common.Feed.List.ConfirmationDeleteItemTitle")}
                        message={this.props.t("Common.Feed.List.ConfirmationDeleteItemMessage")}
                        onClose={
                            (result) => {

                                if (result) {
                                    this.props.onRemovePublication(uid, item.publicationId)
                                        .then((ok) => {

                                            if (ok)
                                                this.props.snackbar.showMessage(this.props.t("Common.Feed.Messages.ListPublicationRemovedSuccess"), "success");
                                            else
                                                this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");

                                            this.setState({ dialog: null });
                                        })
                                        .catch((error) => {
                                            this.setState({ dialog: null, postLastError: error });
                                        });
                                }
                                else {
                                    this.setState({ dialog: null });
                                }

                                // Handled.
                                resolve(true);
                            }
                        }
                    />
                )
            });

        });
    };

    ///
    private handleApproval = (uid: string, publicationId: string, actionId: string, approved: boolean, notes: string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {

            this.props.onProcessSuggestionApproval(uid, publicationId, actionId, approved, notes)
                .then((result) => {
                    if (result) {
                        this.props.snackbar.showMessage(approved ? this.props.t("Common.Feed.Messages.SuggestionApproveSuccess") : this.props.t("Common.Feed.Messages.SuggestionReproveSuccess"), "success");
                    }
                    resolve(result);
                });
        });
    };

    ///
    public componentDidMount() {
        if (this.props.onGetRefenrence) this.props.onGetRefenrence(this);
        this.feedReset();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (prevProps.listId != this.props.listId) {
            this.feedReset();
        }
    }

    ///
    public render() {
        const { classes, feed, feed: { lastError, totalRecords, loading }, snackbar, canAdd, canAddSuggestion } = this.props;
        const { postLastError, dialog } = this.state;

        return (
            <>
                {dialog}

                <RequestErrorDialog
                    open={postLastError != null}
                    error={postLastError}
                    onClose={() => this.setState({ postLastError: null })}
                />

                {
                    (totalRecords > 0 || this.isFiltered() || canAdd || canAddSuggestion) &&
                    <MuiContainer margin="normal">
                        {this.renderAdvFilter()}
                    </MuiContainer>
                }

                {
                    totalRecords > 0 &&
                    <MuiContainer margin="normal">
                        <CountFilter
                            count={totalRecords}
                            filtered={this.isFiltered()}
                            resource="Common.Feed.Filter.PublicationResultText"
                            filteredResource="Common.Feed.Filter.PublicationFilteredResultText"
                            onResetFilter={() => this.advFilterRef.resetFilter()}
                        />
                    </MuiContainer>
                }

                <CardManager
                    classes={classes}
                    feedType={FeedType.List}
                    feed={feed}
                    snackbar={snackbar}

                    onBeforeDelete={this.handleBeforeDelete}

                    onRemovePublication={this.props.onRemovePublication}
                    onReloadPublication={this.props.onReloadPublication}
                    onExpandPublication={this.props.onExpandPublication}
                    onUpdatePublication={this.props.onUpdateFeedData}

                    onRemoveFromFeed={this.props.onRemoveFromFeed}
                    onGetFeed={(startIndex: number, endIndex: number) => this.props.onGetFeed(this.filter, this.orderBy, startIndex, endIndex)}

                    onApprovalRequest={this.handleApproval}
                    onSidebarResetRequest={this.props.onSidebarResetRequest}
                    onFeedReset={() => this.props.onFeedReset()}
                />

                {
                    lastError != null
                        ? <RequestErrorReport error={lastError} />
                        : totalRecords == 0 && !loading && !this.isFiltered()
                            ? <MuiMessageBox variant="info" message={this.props.t("Common.Feed.Filter.PublicationFilteredResultText_zero")} />
                            : totalRecords == 0 && !loading && this.isFiltered()
                                ? (
                                    <MuiMessageBox
                                        variant="warning"
                                        action={<ButtonResetFilter color="warning" onClick={() => this.advFilterRef.resetFilter()} />}
                                        message={this.props.t("Common.Feed.Filter.PublicationResultText_zero")}
                                    />
                                )
                                : null
                }
            </>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

function mapStateToProps(state: ApplicationState): IStateProps {
    return {
        feed: state.feedPrivate
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, void, Action<any>>, ownProps: IProps): IDispatchProps {
    const action = new FeedActions.ListFeedAction(ownProps.listId);

    return {
        onAddPublication: (publicationId) => dispatch(action.addItemPublication(publicationId)),
        onReloadPublication: (uid, publicationId) => dispatch(action.reloadPublication(uid, publicationId)),
        onRemovePublication: (uid, publicationId) => dispatch(action.removeItemPublication(uid, publicationId)),
        onExpandPublication: (uid, publicationId) => dispatch(action.getPublicationFullContent(uid, publicationId)),
        onUpdateFeedData: (newItemDto) => dispatch(action.updateFeedData(newItemDto)),
        onRemoveFromFeed: (uid, publicationId) => dispatch(action.removeFeedData(uid, publicationId)),
        onFeedReset: () => dispatch(action.feedReset()),
        onProcessSuggestionApproval: (uid, publicationId, actionId, approved, notes) => dispatch(action.processSuggestionApproval(uid, publicationId, actionId, approved, notes)),


        onGetFeed: (filter, orderBy, startIndex, endIndex) => dispatch(action.getFeed(filter, orderBy, startIndex, endIndex)),

        onSidebarResetRequest: () => dispatch(SideBarActions.reset()),

        executeFeedMessage: (messageType) => action.executeFeedMessage(messageType, dispatch)
    };
}

export default connect<IStateProps, IDispatchProps>(mapStateToProps, mapDispatchToProps)(withSnackbar(withTranslation()(FeedListItemsComponent)));
